const swiperMeetThumbs = new Swiper(".swiper-meet-thumbs", {
  // Optional parameters
  loop: false,
  slidesPerView: 3,
  slidesPerGroup: 1,
  centeredSlides: true,
  spaceBetween: 0,

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-meet-next",
    prevEl: ".swiper-meet-prev",
  },
});

const swiperMeetContent = new Swiper(".swiper-meet-content", {
  autoHeight: true,
  loop: false,
  slidesPerView: 1,
  effect: "fade",

  fadeEffect: {
    crossFade: true,
  },
});

swiperMeetThumbs.controller.control = swiperMeetContent;
swiperMeetContent.controller.control = swiperMeetThumbs;
